import api from '../services/api';

const uploadsApi = {
  uploadFile: (file, destinationPath, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('destinationPath', destinationPath);

    return api.post('/uploads', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    });
  },

  getSecureUrl: async (path) => {
    try {
      const response = await api.post('/uploads/get-secure-url', { path });
      return response.data.url;
    } catch (error) {
      console.error('Error fetching secure URL:', error);
      throw error;
    }
  },
};

export default uploadsApi;